export default __webpack_public_path__ + "static/media/submenu-aboutus.e42afb27.jpg";